import type { RootState } from "@/store"
import { useDispatch, useSelector, useStore } from "react-redux"
import DialogPassos, { type ItemPersonalizado } from "@/components/catalogo-kiosk/dialog-passos"
import { atualizarKiosk, type CartItem } from "@/store/self-service-kiosk-slice"
import { aplicarItemNoCarrinho } from "./carrinho-totem"

interface DialogPassosCheckoutProps {
    editingCartItem: CartItem | null
    onClose: () => void
    /** Quantidade escolhida no detalhe do produto antes das opções. */
    quantidade?: number
}

/**
 * Wizard de passos do totem checkout: o produto vem do slice do kiosk
 * (`stepDialogProduct`) e o item confirmado entra no carrinho da comanda.
 */
function DialogPassosCheckout({ editingCartItem, onClose, quantidade = 1 }: DialogPassosCheckoutProps): JSX.Element {
    const dispatch = useDispatch()
    const store = useStore<RootState>()
    const produto = useSelector((state: RootState) => state.selfServiceKiosk.stepDialogProduct)

    const confirmar = ({ selecoes }: ItemPersonalizado): void => {
        if (!produto) return

        const cartItems = store.getState().selfServiceKiosk.cartItems
        const atualizado = aplicarItemNoCarrinho({ produto, selecoes, cartItems, editingCartItem, quantidade })

        dispatch(atualizarKiosk({ cartItems: atualizado, stepDialogProduct: null }))
        onClose()
    }

    return (
        <DialogPassos
            produto={produto}
            passosSalvos={editingCartItem?.passos ?? null}
            onFechar={onClose}
            onConfirmar={confirmar}
        />
    )
}

export default DialogPassosCheckout
